//#region Libraries
import { useState } from "react";
//#endregion
//#region Styles
import { TitleSection } from "components/styles";
import { Container } from "./styles";
//#endregion
//#region Components
import CustomTabs from "components/CustomTabs/CustomTabs";
import Filters from "./components/Filters/Filters";
import ScheduleForm from "./components/ScheduleForm/ScheduleForm";
import NonBusinessDaysForm from "./components/NonBusinessDaysForm/NonBusinessDaysForm";
import DialogConfirmSave from "./components/Dialogs/DialogConfirmSave/DialogConfirmSave";
import DialogConfirmDelete from "./components/Dialogs/DialogConfirmDelete/DialogConfirmDelete";
import DialogErrorNotification from "./components/Dialogs/DialogErrorNotification/DialogErrorNotification";
import GuideMessage from "./components/GuideMessage/GuideMessage";
//#endregion
//#region Utils
import { TITLE_TAB_VIEWS } from "../../utils/constants";
import useSpaceList from "../../utils/hooks/useSpaceList";
import useSettingsResourceScheduleAdminContext from "../../context/useSettingsResourceScheduleAdminContext";
import useShowDialogAlert from "components/DialogAlert/utils/hooks/useDialogAlert";
//#endregion

const RegisterSchedule = ({
    filters, registerScheduleData, 
    cancelAction
}) => {
    const { loadingRequest } = useSettingsResourceScheduleAdminContext();
    //#region States
    const [currentTabIdx, setCurrentTabIdx] = useState(0);
    const [saveActionObj, setSaveActionObj] = useState(null);
    const [deleteActionObj, setDeleteActionObj] = useState(null);
    const [dialogErrorNotificationProps, setDialogErrorNotificationProps] = useState(null);
    //#endregion
    const dialogConfirmSave = useShowDialogAlert();
    const dialogConfirmDelete = useShowDialogAlert();
    const dialogErrorNotification = useShowDialogAlert();
    const spaceList = useSpaceList({
        loadingRequest, filters: filters.value
    });
    //#region Functions
    const navigateTab = idx => {
        setCurrentTabIdx(idx);
    }
    const openDialogConfirmSave = saveActionObj => {
        setSaveActionObj(saveActionObj);
        dialogConfirmSave.open();
    }
    const openDialogConfirmDelete = deleteActionObj => {
        setDeleteActionObj(deleteActionObj);
        dialogConfirmDelete.open();
    }
    const openDialogErrorNotification = props => {
        setDialogErrorNotificationProps(props);
        dialogErrorNotification.open();
    }
    //#endregion
    const views = [
        <ScheduleForm
            filters={filters}
            registerScheduleData={registerScheduleData}
            openDialogConfirmSave={openDialogConfirmSave}
            openDialogConfirmDelete={openDialogConfirmDelete}
            openDialogErrorNotification={openDialogErrorNotification}
            cancelRegisterSchedule={cancelAction}/>,
        <NonBusinessDaysForm
            filters={filters}
            registerScheduleData={registerScheduleData}
            openDialogConfirmSave={openDialogConfirmSave}
            openDialogConfirmDelete={openDialogConfirmDelete}
            openDialogErrorNotification={openDialogErrorNotification}
            cancelRegisterSchedule={cancelAction}/>
    ];
    return (
        <>
            <Container>
                <TitleSection fontWeight="900">Registrar Horarios</TitleSection>
                <Filters
                    filters={filters}
                    spaceList={spaceList} />
                {filters.areCompleted()
                    ? <>
                        <CustomTabs
                            viewTabTitles={TITLE_TAB_VIEWS}
                            currentTabIdx={currentTabIdx}
                            changeCurrentTabIdx={navigateTab} />
                        {views[currentTabIdx] || views[0]}
                    </>
                    : <GuideMessage />}
            </Container>
            <DialogConfirmSave
                dialog={dialogConfirmSave}
                saveActionObj={saveActionObj} />
            <DialogConfirmDelete
                dialog={dialogConfirmDelete}
                deleteActionObj={deleteActionObj} />
            <DialogErrorNotification
                dialog={dialogErrorNotification}
                props={dialogErrorNotificationProps} />
        </>
    );
}

export default RegisterSchedule;